import { render, staticRenderFns } from "./AlertDialog.vue?vue&type=template&id=4c54245e&scoped=true&"
import script from "./AlertDialog.vue?vue&type=script&lang=ts&"
export * from "./AlertDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AlertDialog.vue?vue&type=style&index=0&id=4c54245e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c54245e",
  null
  
)

export default component.exports